export default "__VITE_ASSET__DF0QTUlW__"